import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useState, useCallback, useRef, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import LocationCard from "./Card";
import { staticJSS } from "./Detail";
import { FinderCard, NoLocationsFound } from "./LocationFinder";
import { MdLocationOn } from 'react-icons/md';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import FilterAccordionInput from "../accordion/AccordionFilterInput";
import { Formik } from "formik";
import { connect, ReactReduxContext } from 'react-redux';
import { locationDuck } from "../../ducks/location";
import { debounce } from "lodash";
import { toCamel } from "../../util";
import { Form, Field } from 'formik';
import { FormInput, FormSelect } from '../forms/elements';
import Wrapper from '../wrapper/Wrapper';
var locationOperations = locationDuck.operations;

function getMiles(i) {
  return i * 0.000621371192;
}

var toTimeFormat = function toTimeFormat(data) {
  return new Date(data * 1000).toUTCString().match(/(\d\d:\d\d)/)[0];
};

var TripPlannerMarkup = function TripPlannerMarkup(props) {
  var _props$tripPlannerAdd2, _props$tripPlannerAdd3;

  var changeTripPlanner = props.changeTripPlanner,
      locationFinderErr = props.locationFinderErr,
      _props$results = props.results,
      results = _props$results === void 0 ? [] : _props$results,
      tripPlannerLoc = props.tripPlannerLoc,
      mapActive = props.mapActive,
      _props$tripPlannerAdd = props.tripPlannerAddress,
      tripPlannerAddress = _props$tripPlannerAdd === void 0 ? {} : _props$tripPlannerAdd,
      _props$savePathInfo = props.savePathInfo,
      savePathInfo = _props$savePathInfo === void 0 ? function () {
    return "";
  } : _props$savePathInfo,
      _props$setTripPlanner = props.setTripPlannerLoc,
      setTripPlannerLoc = _props$setTripPlanner === void 0 ? function () {
    return "";
  } : _props$setTripPlanner,
      _props$pathInfo = props.pathInfo,
      pathInfo = _props$pathInfo === void 0 ? {} : _props$pathInfo;
  var routes = pathInfo.routes;

  var _ref = Array.isArray(routes) ? routes[0] : {},
      _ref$summary = _ref.summary,
      summary = _ref$summary === void 0 ? {} : _ref$summary;

  var lengthInMeters = summary.lengthInMeters,
      travelTimeInSeconds = summary.travelTimeInSeconds;
  useEffect(function () {
    savePathInfo({});
    setTripPlannerLoc([]);
  }, []);
  var getLocationsWrapper = useCallback(debounce(function (address1, address2) {
    if (address1 && address2) {
      changeTripPlanner({
        address1: address1,
        address2: address2
      });
    }
  }, 1500), []);
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-location-finder__finder-wrapper"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "cb-type-display-1 cb-color-red-900 plr-15"
  }, "Visit A Store on Your Trip"), /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      address1: (props === null || props === void 0 ? void 0 : (_props$tripPlannerAdd2 = props.tripPlannerAddress) === null || _props$tripPlannerAdd2 === void 0 ? void 0 : _props$tripPlannerAdd2.address1) || "",
      address2: (props === null || props === void 0 ? void 0 : (_props$tripPlannerAdd3 = props.tripPlannerAddress) === null || _props$tripPlannerAdd3 === void 0 ? void 0 : _props$tripPlannerAdd3.address2) || ""
    }
  }, function (props) {
    var _props$values, _props$values2;

    var values = props.values,
        setFieldValue = props.setFieldValue;
    return /*#__PURE__*/React.createElement("div", {
      className: "plr-15"
    }, /*#__PURE__*/React.createElement("div", {
      className: "position-relative"
    }, /*#__PURE__*/React.createElement(FilterAccordionInput, _extends({}, props, {
      controlled: true,
      value: (_props$values = props.values) === null || _props$values === void 0 ? void 0 : _props$values.address1,
      name: "address1",
      label: "Start Location",
      onChange: function onChange(e) {
        setFieldValue("address1", e);
        getLocationsWrapper(e, values.address2);
      }
    }))), /*#__PURE__*/React.createElement("div", {
      className: "position-relative"
    }, /*#__PURE__*/React.createElement(FilterAccordionInput, _extends({}, props, {
      controlled: true,
      value: (_props$values2 = props.values) === null || _props$values2 === void 0 ? void 0 : _props$values2.address2,
      label: "End Location",
      onChange: function onChange(e) {
        setFieldValue("address2", e);
        getLocationsWrapper(values.address1, e);
      },
      name: "address2"
    }))), Boolean(!locationFinderErr && Array.isArray(tripPlannerLoc) && tripPlannerLoc.length) && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", null, Array.isArray(tripPlannerLoc) ? "".concat(tripPlannerLoc.length, " Stores Along your Trip") : "")), /*#__PURE__*/React.createElement(Col, {
      className: "text-right"
    }, /*#__PURE__*/React.createElement("a", {
      href: "https://www.google.pl/maps/dir/".concat(tripPlannerAddress === null || tripPlannerAddress === void 0 ? void 0 : tripPlannerAddress.address1, "/").concat(tripPlannerAddress === null || tripPlannerAddress === void 0 ? void 0 : tripPlannerAddress.address2)
    }, "Directions"))));
  }), /*#__PURE__*/React.createElement(Wrapper, {
    layout: {
      background: "default"
    },
    className: "cb-location-finder__cards mt-16"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, Boolean(!locationFinderErr && Array.isArray(tripPlannerLoc) && tripPlannerLoc.length) ? tripPlannerLoc.map(function (el, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: "mt-16"
    }, /*#__PURE__*/React.createElement(FinderCard, {
      data: el,
      key: "finder-".concat(i),
      handlePreferred: function handlePreferred() {
        return "";
      },
      index: i,
      mapActive: mapActive
    }));
  }) : /*#__PURE__*/React.createElement(NoLocationsFound, null)))));
};

var mapStateToProps = function mapStateToProps(state) {
  var _ref2;

  return _ref2 = {
    results: state.location.results,
    zipcode: state.location.zipcode,
    isLoading: state.location.isLoadingZipcode,
    isError: state.location.isError,
    err: state.location.err,
    mapActive: state.location.mapActive
  }, _defineProperty(_ref2, "results", state.location.results), _defineProperty(_ref2, "zipcode", state.location.zipcode), _defineProperty(_ref2, "tripPlannerAddress", state.location.tripPlannerAddress), _defineProperty(_ref2, "locationFinderErr", state.location.locationFinderErr), _defineProperty(_ref2, "tripPlannerLoc", state.location.tripPlannerLoc), _defineProperty(_ref2, "pathInfo", state.location.pathInfo), _ref2;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    changeTripPlanner: function changeTripPlanner(obj) {
      return dispatch(locationOperations.changeTripPlanner(obj));
    },
    setTripPlannerLoc: function setTripPlannerLoc(plannerArray) {
      return dispatch(locationOperations.setTripPlannerLoc(plannerArray));
    },
    savePathInfo: function savePathInfo(pathInfo) {
      return dispatch(locationOperations.savePathInfo(pathInfo));
    } // dispatch(locationOperations.changeZipCode(text)),

  };
};

export var TripPlanner = connect(mapStateToProps, mapDispatchToProps)(TripPlannerMarkup);